import React from "react";
import { useSelector } from "react-redux";
import { IPhysicalStatus } from "../PhysicalStatus";
import { IFinancialStatus } from "../FinancialStatus";
import { numberTdStyle } from "../../../ProjectPDF";

const ProjectProgress = () => {
  const physicalStatus: IPhysicalStatus = useSelector(
    (state: any) => state?.projectInfo?.physicalStatus,
  );
  const financialStatus: IFinancialStatus = useSelector(
    (state: any) => state?.projectInfo?.financialStatus,
  );
  let financialProgress =
    useSelector((state: any) => state?.projectInfo?.financialProgress) || null;
  // const {adpShare, donorFund} = useSelector((state: any) => state?.projectInfo)
  // const status = useSelector((state:any)=> state?.projectInfo?.financialStatus)

  const getSpendingByDate = (date: string): number | undefined => {
    const spendingRecord = financialStatus?.acum_spending?.find(
      (record) => record.date === date,
    );
    return spendingRecord ? spendingRecord.cumulative_spending : undefined;
  };

  return (
    <>
      <div className="table-container">
        <table>
          <thead>
            <tr>
              <th>Progress Reporting Date</th>
              <th>Cumulative Spending US$ Million</th>
              <th>Financial Progress %</th>
              <th>Physical Progress %</th>
            </tr>
          </thead>
          <tbody>
            {physicalStatus?.acum_physical?.map((info, index: number) => {
              const spending = getSpendingByDate(info.date) || 0;

              if (index > 0 || !financialProgress) {
                financialProgress = (
                  (spending /
                    (financialStatus.foreign +
                      financialStatus.local +
                      (financialStatus.additional_financing || 0))) *
                  100
                ).toFixed(2);
              }

              // console.log(spending, financialStatus)
              return (
                <tr key={"tr-progress-" + index}>
                  <td key={"td-progress-date-" + index} style={numberTdStyle}>
                    {info.date}
                  </td>
                  <td key={"td-spending-date-" + index} style={numberTdStyle}>
                    {spending}
                  </td>
                  <td
                    key={"td-physical-progress-date-" + index}
                    style={numberTdStyle}
                  >
                    {financialProgress}
                  </td>
                  <td
                    key={"td-progress-percent-date-" + index}
                    style={numberTdStyle}
                  >
                    {info.physical_progress}
                  </td>
                </tr>
              );
            })}
            <tr>
              {/*    <td style={tdStyle}>{status?.cost}</td>*/}
              {/*    <td style={tdStyle}>{status?.foreign}</td>*/}
              {/*    <td style={tdStyle}>{status?.local}</td>*/}
              {/*    <td style={tdStyle}>{signing_date}</td>*/}
            </tr>
          </tbody>
        </table>
      </div>
    </>
  );
};

export default ProjectProgress;
